<div class="filter-page-container tw-flex tw-flex-flow-row-wrap filter-page-container-temp"
     style="background: transparent; width: 98%; gap: 8px;">

    <!-- 🔍 Recherche unique sur mobile -->
    @if (subBreakpointObserver.value.breakpoints[BreakpointsLib.SmallMobile]) {
        <div class="search-mobile search-mobile-temp" style="width: 100%; display: flex; gap: 8px;">
            <!-- Champ de recherche -->
            <mat-form-field appearance="outline" style="flex: 1; font-size: 17px;">
                <mat-icon matPrefix>search</mat-icon>
                <input
                    type="text"
                    matInput
                    placeholder="{{ '' | libTranslateLang:'artist, event':'artiste, événement' }}"
                    [(ngModel)]="search"
                    (keyup.enter)="searchEvent()"
                />
                <mat-icon matSuffix>close</mat-icon>
            </mat-form-field>

            <!-- Bouton filtres -->
<!--            <button mat-icon-button color="primary" (click)="toggleFilters()">-->
<!--                <mat-icon>@if (showFilters) { close } @else { tune } &lt;!&ndash; ou 'filter_alt' &ndash;&gt;</mat-icon>-->
<!--            </button>-->
            <div class="filter-page-container-bt-temp">
                <button mat-raised-button color="primary" class=""
                        style="height: 54px;"
                        aria-label=" icon button with a menu icon" (click)="toggleFilters()">
                    <mat-icon style="font-size: 27px;">@if (showFilters) { close } @else { tune } <!-- ou 'filter_alt' --></mat-icon>

                </button>
            </div>

        </div>

        <!-- Bouton de recherche (visible quand le clavier est actif ou pour soumettre) -->
        @if (!showFilters) {
            <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
        }


        <!-- Affichage conditionnel des filtres -->
        @if (showFilters) {
            <div style="width: 100%; display: flex; flex-direction: column; gap: 12px; padding-top: 8px; border-top: 1px solid #eee;">
                @if (showProvince) {
                    <ng-container *ngTemplateOutlet="provinceTemplate"></ng-container>
                }
                @if (showLocation && locationVenue?.length) {
                    <ng-container *ngTemplateOutlet="locationTemplate"></ng-container>
                }
                @if (showCategory && category?.length) {
                    <ng-container *ngTemplateOutlet="categoryTemplate"></ng-container>
                }
                @if (showDate) {
                    <ng-container *ngTemplateOutlet="dateTemplate"></ng-container>
                }


                <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
            </div>
        }
    }


    @else {
        @if (showSearch) {
            <ng-container *ngTemplateOutlet="searchTemplate"></ng-container>
        }
        @if (showProvince) {
            <ng-container *ngTemplateOutlet="provinceTemplate"></ng-container>
        }
        @if (showLocation && locationVenue?.length) {
            <ng-container *ngTemplateOutlet="locationTemplate"></ng-container>
        }
        @if (showCategory && category?.length) {
            <ng-container *ngTemplateOutlet="categoryTemplate"></ng-container>
        }
        @if (showDate) {
            <ng-container *ngTemplateOutlet="dateTemplate"></ng-container>
        }
        <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
    }

</div>

<!-- ========== NG-TEMPLATES (réutilisés) ========== -->

<!-- 🔍 Search (desktop only) -->
<ng-template #searchTemplate>
    <div class="search">
        <mat-form-field appearance="outline" style="font-size: 17px; width: 100%;">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>{{ "" | libTranslateLang:'Search':'Rechercher' }}</mat-label>
            <input
                type="text"
                matInput
                placeholder="{{ 'artiste, événement' | libTranslateLang:'artist, event':'artiste, événement' }}"
                [(ngModel)]="search"
                name="search"
                (keyup.enter)="searchEvent()"
            />
            <mat-icon matSuffix  (click)="reset()">close</mat-icon>
        </mat-form-field>
    </div>
</ng-template>

<!-- 🌍 Province Template -->
<ng-template #provinceTemplate>
    <!-- (contenu identique à avant) -->
    <div class="filter-page-border select-province">
        <button mat-flat-button [matMenuTriggerFor]="menuProvinces" style="background: transparent;">
            @if (provinceSelected && provinceSelected.ab) {
                {{ provinceSelected.ab }}
            } @else {
            {{ "" | libTranslateLang:'Province':'Province' }}
        }
            <mat-icon>expand_more</mat-icon>
        </button>
        @if (postal) {
            <div class="tw-flex tw-flex-flow-row-wrap" style="justify-content: space-around">
                <h3 style="text-transform: uppercase">{{ postal }}</h3>
            </div>
        }
    </div>
    <mat-menu #menuProvinces [overlapTrigger]="true" >
        <!-- (menu identique) -->
        <mat-form-field style="color:var(--theme-primary-300); font-size: 17px; max-width: 500px; margin: 20px">
            <span matPrefix class="material-symbols-outlined">location_on</span>
            <mat-label>{{ "" | libTranslateLang:'Postal Code':'Code postal' }}</mat-label>
            <input
                name="postal"
                pattern="^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?$"
                type="tel"
                matInput
                placeholder="Exp:H0N"
                style="text-transform: uppercase"
                #postalRef="ngModel"
                [(ngModel)]="postal"
                (click)="$event.stopPropagation()"
            />
            <button matSuffix mat-raised-button color="primary" style="text-transform: uppercase">
                {{ "" | libTranslateLang:'Apply':'Appliquer' }}
            </button>
            <mat-error>
                <tw-form-error-message [errors]="postalRef.errors"></tw-form-error-message>
            </mat-error>
        </mat-form-field>

        @for (st of provinces; track st) {
            <div class="tw-hover-menu" style="width: 300px; margin: 0 10px">
                <button
                    class="tw-btn-menu"
                    (click)="selectProvince(st)"
                    [ngClass]="st.ab === provinceSelected?.ab ? 'tw-btn-menu-active' : ''"
                >
                    @if (translate.currentLang !== 'fr') {
                        {{ st.nameEn }}
                    } @else {
                    {{ st.nameFr }}
                }
                </button>
            </div>
        }
    </mat-menu>
</ng-template>

<!-- 📍 Location Template -->
<ng-template #locationTemplate>
    <div class="filter-page-border select-location">
        <mat-form-field style="width: 100%; max-width: 500px;" appearance="outline">
            <mat-label>{{ "" | libTranslateLang:'Location':'Lieu' }}</mat-label>
            <mat-select
                [(ngModel)]="locationSelected"
                name="locationSelected"
                [multiple]="multiple"
                (ngModelChange)="searchEvent()"
            >
                <mat-option [value]="null">
                    {{ "" | libTranslateLang:'All locations':'Tous les lieux' }}
                </mat-option>
                @for (loc of locationVenue; track loc) {
                    <mat-option [value]="loc">{{ loc.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</ng-template>

<!-- 🎭 Category Template -->
<ng-template #categoryTemplate>
<!--    <pre>{{category | json}}</pre>-->
    <div class="filter-page-border select-category">
        <mat-form-field style="width: 100%; max-width: 500px;" appearance="outline">
            <mat-label>{{ "" | libTranslateLang:'Category':'Catégorie' }}</mat-label>
            <mat-select
                [(ngModel)]="categorySelected"
                name="categorySelected"
                [multiple]="multiple"
                (ngModelChange)="searchEvent()"
            >
                <mat-option [value]="null">
                    {{ "" | libTranslateLang:'All categories':'Toutes les catégories' }}
                </mat-option>
                @for (cat of category; track cat) {
                    <mat-option [value]="cat">
                        @if (translate.currentLang === 'fr') {
                            {{ cat.nameLangue1 || cat.smallName }}
                        } @else {
                        {{ cat.nameLangue2 || cat.smallName }}
                    }
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</ng-template>

<!-- 📅 Date Template -->
<ng-template #dateTemplate>
    <mat-form-field appearance="outline" style="width: 100%; max-width: 500px;">
        <mat-label>{{ "" | libTranslateLang:'Enter a date range':'Entrez une plage de dates' }}</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker" >
            <input matStartDate placeholder="{{ 'Start date' | libTranslateLang:'Start date':'Date de début' }}" [(ngModel)]="startDate" readonly (click)="rangePicker.open()" />
            <input matEndDate placeholder="{{ 'End date' | libTranslateLang:'End date':'Date de fin' }}" [(ngModel)]="endDate" readonly (click)="rangePicker.open()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker (closed)="onDateRangePickerClosed()">
            <mat-date-range-picker-actions>
                <button mat-button (click)="resetDates()">{{ "" | libTranslateLang:'Reset':'Réinitialiser' }}</button>
                <button mat-button matDateRangePickerCancel>{{ "" | libTranslateLang:'Cancel':'Annuler' }}</button>
                <button mat-button matDateRangePickerApply>{{ "" | libTranslateLang:'Apply':'Appliquer' }}</button>
            </mat-date-range-picker-actions>
        </mat-date-range-picker>
    </mat-form-field>
</ng-template>

<!-- 🛠️ Buttons Template (desktop only) -->
<ng-template #buttonsTemplate>
    <div class="filter-page-container-bt-temp" style="display: flex; flex-direction: row; align-items: stretch; gap: 8px; width: 100%;">
        <button style="flex: 1;height: 54px;" mat-raised-button color="primary" (click)="searchEvent()">
            {{ "" | libTranslateLang:'Search':'Rechercher' }}
        </button>
        <!--
        <button style="flex: 1;" mat-stroked-button color="warn" (click)="clearFilter()">
          {{ "" | libTranslateLang:'Clear':'Effacer' }}
        </button>
        -->
    </div>
</ng-template>
